import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from 'semantic-ui-react'

import Container from './MainModuleRugsRowContainer'

import RecentRugsSegment from 'Components/RecentRugsSegment'

import { isRole } from 'Global/Helpers/userHelpers'

const MainModuleRugsRow = props => {
  const {
    recent,
    recentMarkedForDesigners,
    recentOrders,
    setCurrentIndex,
    togglePreviewRecent,
    togglePreviewRecentMFD,
    togglePreviewRecentOrders,
    user,
  } = props

  let renderRecentMFD
  let renderRecentOrders

  if (isRole(user, 'designer')) {
    if (recentMarkedForDesigners.length > 0) {
      renderRecentMFD = (
        <RecentRugsSegment
          items={3}
          link="/markedForDesigners"
          rugs={recentMarkedForDesigners}
          setCurrentIndex={setCurrentIndex}
          title="Recent Rugs Marked for Designers"
          togglePreview={togglePreviewRecentMFD}
          user={user}
        />
      )
    }
  }

  if (isRole(user, 'advisor') && !isRole(user, 'designer')) {
    if (recentOrders.length > 0) {
      renderRecentOrders = (
        <RecentRugsSegment
          items={3}
          link="/myOrders"
          rugs={recentOrders}
          setCurrentIndex={setCurrentIndex}
          title="My Recent Orders"
          togglePreview={togglePreviewRecentOrders}
          user={user}
        />
      )
    }
  }

  return (
    <Grid.Row>
      <Grid.Column width={recent.length === 3 ? 8 : 16}>
        {recent.length > 0 && (
          <RecentRugsSegment
            items={recent.length}
            link="/search"
            rugs={recent}
            setCurrentIndex={setCurrentIndex}
            title="Recent Rugs"
            togglePreview={togglePreviewRecent}
            user={user}
          />
        )}
      </Grid.Column>

      <Grid.Column width={8}>
        {renderRecentMFD}
        {renderRecentOrders}
      </Grid.Column>
    </Grid.Row>
  )
}

MainModuleRugsRow.propTypes = {
  recent: PropTypes.array.isRequired,
  recentMarkedForDesigners: PropTypes.array.isRequired,
  recentOrders: PropTypes.array.isRequired,
  setCurrentIndex: PropTypes.func.isRequired,
  togglePreviewRecent: PropTypes.func.isRequired,
  togglePreviewRecentMFD: PropTypes.func.isRequired,
  togglePreviewRecentOrders: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default Container(MainModuleRugsRow)
